import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import api from '~/utils/api';
import { Pagination } from '~/types';
import { UploadEquipamentosVigentes } from '~/hooks/useActiveEquipaments/types';
import { formatInTimeZone } from '~/utils/formatToTimeZone';

export async function getActiveEquipaments(): Promise<
  UploadEquipamentosVigentes[]
> {
  const { data } = await api.get<Pagination<UploadEquipamentosVigentes>>(
    '/equipamentos_vigentes/',
  );

  return data.results.map(equipament => ({
    ...equipament,
    data_upload_fmt: formatInTimeZone(
      `${equipament.data_upload}`,
      'dd/MM/yyyy HH:mm',
      'America/Sao_Paulo',
    ),
  }));
}

export function useActiveEquipaments(
  options: UseQueryOptions<UploadEquipamentosVigentes[], unknown> = {},
): UseQueryResult<UploadEquipamentosVigentes[], unknown> {
  return useQuery<UploadEquipamentosVigentes[], unknown>(
    ['activeEquipaments'],
    () => getActiveEquipaments(),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
